import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid, Box} from '@mui/material';
import apiCall, {setUserToken} from '@/utils/api';
import Loader from '@/shared/Loader';
import VolunteersActivities from 'src/containers/FdcMilanoCollaborationAgreements/Charts/VolunteersActivities';

import './styles.scss';

const FdcMilanoCollaborationAgreements = () => {
    const [searchParams] = useSearchParams();
    const container = searchParams.get('container_id');
    const collaborationAgreementSurvey = searchParams.get('collaboration_agreement_survey');
    const monitoringSurvey = searchParams.get('monitoring_survey');

    setUserToken(searchParams.get('token') || '')

    const [loading, setLoading] = useState<boolean>(true);
    const [collaborationAgreementSubmissions, setCollaborationAgreementSubmissions] = useState([]);
    const [monitoringSubmissions, setMonitoringSubmissions] = useState([]);

    const getSurvey = async () => {
        try {
            const responses = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: collaborationAgreementSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });
            const responsesMonitoring = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: monitoringSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });

            setCollaborationAgreementSubmissions(responses.data.submissions);
            setMonitoringSubmissions(responsesMonitoring.data.submissions);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSurvey().then(() => setLoading(false));
    }, []);

    return (
        <Box p={2}>
            {
                !loading && (
                    <>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                            <Grid item xs={12}>
                                <VolunteersActivities
                                    collaborationAgreementSubmissions={collaborationAgreementSubmissions}
                                    monitoringSubmissions={monitoringSubmissions}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            }
            {
                loading && (
                    <Box className='loader-container'>
                        <Loader size={60}/>
                    </Box>
                )
            }
        </Box>
    )
}

export default FdcMilanoCollaborationAgreements;